import { motion } from "framer-motion";
import Sidebar from "@/components/Sidebar";
import { useLocation } from "react-router-dom";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen flex" data-testid="app-layout">
      <Sidebar />
      <main className="ml-64 flex-1 min-h-screen relative">
        <motion.div
          key={pathname}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          className="px-8 pt-8 pb-16 max-w-[1500px] mx-auto"
        >
          {children}
        </motion.div>
      </main>
    </div>
  );
}
